import type { AllRouteEndpoints } from "../routeTypes";

export const analyticsDashboardAppGroupIdEmailEngagementByProvidersData =
  "/analytics_dashboard/:app_group_id/email_engagement_by_providers_data";

export const analyticsDashboardAppGroupIdEmailEngagementByProvidersDataCacheKeys: AllRouteEndpoints[] = [];
